import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

import { renderInstructorPage } from './-route-wrappers';

const SendBulkEmailSms = lazyRouteComponent(() => import('@/_instructor/send-bulk-email-sms'));

export const Route = createFileRoute('/_instructor/send-sms')({
  component: () => renderInstructorPage(SendBulkEmailSms),
});
